import { Alert, AlertDescription } from '@/components/ui/alert';
import { ExclamationTriangleIcon } from '@radix-ui/react-icons';
import { CheckCircleIcon } from 'lucide-react';
import { cn } from '@/utils/utils.ts';

interface StatusAlertProps {
  type: 'success' | 'error';
  message: string;
  className?: string;
}

export function StatusAlert({ type, message, className }: StatusAlertProps) {
  if (!message) return null;

  return (
    <Alert
      variant={type === 'error' ? 'destructive' : 'default'}
      className={cn(
        'flex items-center gap-4',
        type === 'success' && 'border-green-600',
        className
      )}
    >
      <div className="h-4 w-4">
        {type === 'error' ? (
          <ExclamationTriangleIcon className="h-4 w-4" />
        ) : (
          <CheckCircleIcon className="h-4 w-4 text-green-600" />
        )}
      </div>
      <AlertDescription>{message}</AlertDescription>
    </Alert>
  );
}
